var parser = { exports: {} };
export {
  parser as __module
};
//# sourceMappingURL=parser.js.map
